const venues = [
  {
    id: 1,
    name: "Zebulon",
    address: "2478 Fletcher Dr, Los Angeles, CA 90039",
  },
  {
    id: 2,
    name: "Gold Diggers",
    address: "5632 Santa Monica Blvd, Los Angeles, CA 90038",
  },
  {
    id: 3,
    name: "The Echo",
    address: "1822 Sunset Blvd, Los Angeles, CA 90026",
  },
  {
    id: 4,
    name: "The Wiltern",
    address: "3790 Wilshire Blvd, Los Angeles, CA 90010",
  },
  {
    id: 5,
    name: "Hollywood Bowl",
    address: "2301 N Highland Ave, Los Angeles, CA 90068",
  },
  {
    id: 6,
    name: "Pico Union",
    address: "1153 Valencia St, Los Angeles, CA 90015",
  },
  {
    id: 7,
    name: "Gold Fish",
    address: "5043 York Blvd, Los Angeles, CA 90042",
  },
  {
    id: 9,
    name: "Troubadour",
    address: "9081 N Santa Monica Blvd, West Hollywood, CA 90069",
  },
  {
    id: 10,
    name: "Lodge Room",
    address: "104 N Ave 56 2nd floor, Los Angeles, CA 90042",
  },
  {
    id: 11,
    name: "Healing Force of the Universe",
    address: "1200 E Walnut St, Pasadena, CA 91106",
  },
  {
    id: 8,
    name: "Custom Address",
    address: "",
  },
];

export default venues;
